import React from "react"
import PropTypes from "prop-types"
import { startCase } from "lodash"
import { useCurrentRefinements, useRefinementList } from 'react-instantsearch';

const getName = attribute => startCase(attribute.replace(/ostendo/g, ""))

function StringTags({ facetGroup }){

if (facetGroup && 'refinements' in facetGroup) {
const {  refine } = useRefinementList({ attribute: facetGroup.attribute });

   return ( <div>
        {"refinements" in facetGroup
            ? facetGroup.refinements.map(item => item.operator ?(
                <div
                    key={item.label}
                    className="tag"
                    onClick={() => facetGroup.refine(item)}
                >
                    {getName(facetGroup.attribute)}: {item.label}
                    <svg><use xlinkHref="#cross-icon" /></svg>
                </div>) :(
                <div
                    key={item.label}
                    className="tag"
                    onClick={() => refine(item.value)}
                >
                    {getName(facetGroup.attribute)}: {item.label}
                    <svg><use xlinkHref="#cross-icon" /></svg>
                </div>))
            : <div className="tag" onClick={() => refine(item.value)}>
                {getName(facetGroup.attribute)}: {facetGroup.label}
                <svg><use xlinkHref="#cross-icon" /></svg>
            </div>
        }
    </div>)
    }
    else{
        return "";
    }
 }
StringTags.propTypes = {
   facetGroup: PropTypes.object,
	refine: PropTypes.func,
};

function NumericTags({ facetGroup }){
const {  refine } = useRefinementList({ attribute: facetGroup.attribute });

   return ( <div>
        <div className="tag" onClick={() => refine(facetGroup.value)}>
            {getName(facetGroup.attribute)}: {facetGroup.refinements.min} - {facetGroup.refinements.max}
            <svg><use xlinkHref="#cross-icon" /></svg>
        </div>
    </div>)
}
NumericTags.propTypes = {
   facetGroup: PropTypes.object,
	refine: PropTypes.func,
};
function renderComponent(Component, props = {}) {
  return <Component {...props} />;
}
function Tags({ facetGroup, refine }) {
 ({ facetGroup }) => Array.isArray(facetGroup.refinements);
   // console.log('facetGroup');
  //  console.log(facetGroup);
	if(Array.isArray(facetGroup.refinements))
	{
		return renderComponent(StringTags,  {facetGroup: facetGroup, refine: refine });
	}
	else
	{
        return renderComponent(NumericTags, {facetGroup: facetGroup, refine: refine });
	}

}

function CurrentRefinements({  defaultAttribute }){
      const { items, refine } = useCurrentRefinements();

    return (<div className="tag-group"> {console.log( items )}
        {items.filter(item => item.attribute !== defaultAttribute).map(item =>
            <Tags key={item.attribute} facetGroup={item} refine={refine} />)}
    </div>)
}
CurrentRefinements.propTypes = {
  	items: PropTypes.arrayOf(PropTypes.object),
	refine: PropTypes.func,
	defaultAttribute: PropTypes.string,
};
export default CurrentRefinements